export default "__VITE_ASSET__S01lHePT__"